import styled, { css } from 'styled-components';

import type { IStyledCountdownProps, TCountdownBackground } from '../types';
import Typography from '@klv/atoms/typography';
import Grid from '@klv/utils/grid';


export const CountdownGrid = styled(Grid)``;

export const CountdownHeadline = styled(Typography)<{ color: TCountdownBackground; }>`
  margin-bottom: 1.6rem;
  ${({ theme, color }) => `
    color: ${theme.countdown[color].headline};
  `}
`;

export const CountdownContainer = styled.div`
  ${({ theme }) => css`
    text-align: center;
    grid-column: 1 / -1;
    ${theme.screenSize.s576.mediaQuery} {
      grid-column: 2 / -2;
    }
  `}
`;

export const StyledCountdown = styled.div<IStyledCountdownProps>`
  ${({ theme, background, displayed, $customPaddingTop, $customPaddingBottom }) => `
    transition: all .5s ease-in-out;
    background-color: ${theme.colors[background]};
    width: 100%;
    max-height: ${displayed ? '40' : '0'}rem;
    overflow: hidden;

    ${(displayed && $customPaddingTop === 'default') ?  `padding-top: ${theme.globalVerticalPadding};` : ''}
    ${(displayed && $customPaddingTop === 'none')  ? 'padding-top: 0px;' : ''}
    ${(displayed && $customPaddingTop === 'small') ? 'padding-top: 2rem;' : ''}
    ${!displayed  ? 'padding: 0px;' : ''}

    ${(displayed && $customPaddingBottom === 'default') ? `padding-bottom: ${theme.globalVerticalPadding};` : ''}
    ${(displayed && $customPaddingBottom === 'none')  ? 'padding-bottom: 0px;' : ''}
    ${(displayed && $customPaddingBottom === 'small') ? 'padding-bottom: 2rem;' : ''}
    ${!displayed  ? 'padding: 0px;' : ''}

    ${theme.screenSize.s768.mediaQuery} {
      ${(displayed && $customPaddingBottom === 'small') ? 'padding-bottom: 2.8rem;' : ''}
      ${(displayed && $customPaddingTop === 'small') ? 'padding-top: 2.8rem;' : ''}

    }
  `}
`;
